module.exports = __webpack_public_path__ + "img/closeFullScreen.eb6f5cfb.svg";